import { useEffect, useState } from 'react';
import OptimizedImage from './OptimizedImage';
import { heroWomanSlides } from '../assets/menuImages';

const SLIDE_INTERVAL = 5000;

function HeroWomanShowcase({ className = '', ...imgProps }) {
  const slides = heroWomanSlides;
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (slides.length < 2) return undefined;

    const media = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;
    if (media && media.matches) return undefined;

    const timer = setInterval(() => {
      setActive((current) => (current + 1) % slides.length);
    }, SLIDE_INTERVAL);

    return () => clearInterval(timer);
  }, [slides.length]);

  if (slides.length < 2) {
    return (
      <OptimizedImage
        image={slides[0]}
        className={`hero-woman ${className}`}
        fetchPriority="high"
        {...imgProps}
      />
    );
  }

  return (
    <div className={`hero-woman-showcase ${className}`} aria-hidden="true">
      {slides.map((slide, index) => (
        <OptimizedImage
          key={index}
          image={slide}
          alt=""
          className={`hero-woman-slide ${index === active ? 'is-active' : ''}`}
          loading={index === 0 ? undefined : 'lazy'}
          fetchPriority={index === 0 ? 'high' : undefined}
        />
      ))}
    </div>
  );
}

export default HeroWomanShowcase;
